import { render } from "./App.vue?vue&type=template&id=a7d9008e&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./style.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__